import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Images } from '../../utils/images.utils';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'dp-message-error',
    templateUrl: './message-error.component.html',
    styleUrls: ['./message-error.component.scss']
})
export class MessageErrorComponent {
    @Output() public onConfirm = new EventEmitter();
    @Input() public messageError: string;
    @Input() private goBack = true;
    @Input() private routeGoBack: string;
    @Input() public textConfirm = 'Voltar';
    public error = Images.ERROR;

    constructor(private router: Router, private location: Location) {}

    public handleOnConfirm() {
        if (this.goBack) {
            if (this.routeGoBack) {
                this.router.navigate([this.routeGoBack]);
            } else {
                this.location.back();
            }
        } else {
            this.onConfirm.emit();
        }
    }
}
